import { defaultQueryOptions } from 'constants/'
import { useQuery } from 'react-query'
import type { QueryOptions } from 'types'
import { logFactory } from 'utils'
import { usePartnersService } from '../services'

const hookName = 'usePartnerEmployeePartnerShops'
const log = logFactory(hookName)

type UsePartnerEmployeePartnerShopsProps = {
  gid: string
  isPrimaryShop?: boolean
}

const usePartnerEmployeePartnerShops = (
  { gid, isPrimaryShop = false }: UsePartnerEmployeePartnerShopsProps,
  options: QueryOptions = { enabled: true }
) => {
  const { getPartnerEmployeePartnerShops } = usePartnersService()

  const doQuery = async () => {
    log(`💈 Fetching partner employee partner shops`)

    const { data } = await getPartnerEmployeePartnerShops({
      gid,
      isPrimaryShop,
    })

    log(`💈 Found partner employee partner shops`, data)

    return data
  }

  return useQuery([hookName, gid], doQuery, {
    ...defaultQueryOptions,
    ...options,
  })
}

export { usePartnerEmployeePartnerShops }
